export interface WebLoginRequest {
  phoneNumber: string;
  password: string;
}

export interface WebAuthResponse {
  success: boolean;
  message: string;
  data: AuthData;
}

export interface AuthData {
  token: string;
  refreshToken: string;
  user: WebUserInfo;
}

export interface WebUserInfo {
  id: string;
  name: string;
  phoneNumber: string;
  email: string | null;
  role: UserRole;
  branchAccess: BranchAccessInfo[];
  sportAccess: SportAccessInfo[];
  permissions: ManagerPermission[];
}

export interface ManagerPermission {
  branchId: string;
  branchName: string;
  sportId: string;
  sportName: string;
  canViewPlans: boolean;
  canEditPlans: boolean;
  canViewSubscriptions: boolean;
  canConfirmPayment: boolean;
  canAddAttendance: boolean;
}

export interface BranchAccessInfo {
  branchId: string;
  branchName: string;
}

export interface SportAccessInfo {
  sportId: string;
  sportName: string;
}

export enum UserRole {
  User = 0,
  Manager = 1,
  Owner = 2
}
